// extracted by mini-css-extract-plugin
export default {"tooltip":"Do-z","sharingV2":"Eo-z","sharingIconsV2":"Fo-z","links":"Go-z","link":"Ho-z","facebookV2":"Io-z","twitterV2":"Jo-z","pinterestV2":"Ko-z"};